import { render, staticRenderFns } from "./TableMobilePersonComponent.vue?vue&type=template&id=0b87640b&"
import script from "./TableMobilePersonComponent.vue?vue&type=script&lang=js&"
export * from "./TableMobilePersonComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableMobilePersonComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VContainer,VDivider,VProgressLinear})
